import React, { useCallback, useEffect, useRef, useState } from "react"
import API from "../../api"
import { uniqueId } from "lodash"
import { default as dayjs } from "dayjs"

// redux
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { connect } from "react-redux"
import { useQueryParams } from "../../hooks/useQueryParams"
import { useLocation, useNavigate } from "react-router-dom"

import NotificationContainer from "../../components/notification"
import useInfiniteScroll from "../../hooks/useInfiniteScroll"

import RadioButton from "../../components/radioButton"
import { ChevronRight } from "react-feather"
import Button from "../../components/button"

import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js"
import Zoom from "chartjs-plugin-zoom"
import { Line } from "react-chartjs-2"
import PostingCard from "../../components/postingCard"
import { ROUTES } from "../../routes"
import { isEmpty } from "../../helpers/object"
import { debounce } from "../../helpers/debounce"
import Label from "../../components/label"
import { useLanguage } from "@languages/index"

ChartJS.register(Zoom, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

const ICON_ONEULOOK: string = "/assets/icons/ic-oneulook-icon-rounded.svg"

const ReportIndex = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.reports }
  const location = useLocation()
  const navigate = useNavigate()
  const params = useQueryParams()
  //   const title = useDocumentTitle('리포트')

  const orders = [
    { name: languageTexts.index_text_1, value: "hot" },
    { name: languageTexts.index_text_2, value: "cold" }
  ]
  const [selectedOrder, setSelectedOrder] = useState(orders[0])

  const [products, setProducts] = useState(undefined)
  const productPage = useRef(1)

  const [selectedDate, setSelectedDate] = useState<any>(undefined)
  const durations = [
    { name: languageTexts.index_text_3, value: "LAST_TWO_WEEKS" },
    { name: languageTexts.index_text_4, value: "LAST_SIX_MONTHS" }
  ]

  const [selectedChartDuration, setSelectedChartDuration] = useState<any>(durations[0])

  const [chartData, setChartData] = useState<any>()

  const labels = useRef<Array<any>>()
  const counts = useRef<number>(0)

  const date_two_weeks_ago = dayjs().subtract(2, "week").format(languageTexts.date_format2)

  const today = dayjs().format(languageTexts.date_format2)

  const [isPopupBlocked, setIsPopupBlocked] = useState(false)
  useEffect(() => {
    fetchProducts(true)
  }, [selectedOrder])

  const fetchProducts = (refresh?: boolean) => {
    if (refresh) {
      productPage.current = 1
    }

    API.Product.index({
      brandToken: props.auth.token,
      type: "PRODUCT",
      statusFl: 4,
      orderBy: selectedOrder.name == orders[0].name ? "cart_cnt_in_two_weeks_desc" : "cart_cnt_in_two_weeks_asc",
      page: productPage.current
    })
      .then((response) => {
        setProducts(productPage.current === 1 ? response.data.products : products.concat(response.data.products))

        productPage.current = productPage.current + 1
      })
      .catch((error) => {
        props.showModal({
          text: languageTexts.index_text_5
        })
      })
  }

  const renderBanner = () => {
    return (
      <div className="py-[80px] flex flex-col justify-center md:items-center bg-[#121212] xl-bg-white">
        <div className="flex flex-col px-8 md:w-[800px] xl:w-[1024px]">
          <span
            className="font-bold text-5xl tracking-tighter"
            style={{
              color: "#000000"
            }}
          >
            {props.brand.name}
          </span>

          <span className="font-bold text-5xl tracking-tighter text-white">{languageTexts.index_text_6}</span>

          <span className="font-bold text-sm tracking-tighter text-gray-400 mb-[120px]">{}</span>

          <div className="flex flex-col mb-4">
            <div className="flex flex-row mb-[0.9375rem]">
              <span className="font-bold text-white text-[1.375rem]">{languageTexts.index_text_7}</span>
            </div>
            {languageTexts._index_text_8(props.brand.totalClothes, props.brand.diffFromLastApprovedDate)}
          </div>

          <div className="flex flex-col mb-[3rem]">
            <div className="flex flex-row">
              <span className="text-sm tracking-tighter text-[#999999]">{languageTexts._index_text_9(props.brand.name)}</span>
              <span className="text-sm tracking-tighter text-white">{`${props.brand.lastApprovedDate ?? languageTexts.none}`}</span>
            </div>
          </div>

          <div className="flex flex-col mb-4">
            <div className="flex flex-row mb-[0.9375rem]">
              <span className="font-bold text-white text-[1.375rem]">
                {languageTexts.index_text_10}
                <span
                  className="ml-2 px-2 py-1 rounded-full border border-white text-white font-bold text-[0.8125rem]"
                  onClick={() => {
                    navigate(ROUTES.CAMPAIGN_INDEX.PATH)
                  }}
                >
                  {languageTexts.index_text_11}
                </span>
              </span>
            </div>
            <div className="flex flex-row">
              <span className="text-[20px] heading-snug tracking-tighter text-white">{languageTexts._index_text_12(props.brand.totalCampaigns)}</span>
            </div>

            {/* <span className="text-sm tracking-tighter text-[#999999]">
                {`전체 브랜드 재입고 주기 : `}
              </span>
              <span className="text-sm tracking-tighter text-white">
                평균 23.8일
              </span> */}
          </div>
        </div>
      </div>
    )
  }

  const renderProducts = useCallback(() => {
    return (
      <div className="py-[64px] flex flex-col px-5 md:px-10 mx-auto md:w-[800px] xl:w-[1024px]">
        <div className="flex flex-col w-full mb-6">
          <span className="font-bold text-xl tracking-tighter text-black">{languageTexts.index_text_13}</span>
          <span className="text-sm tracking-tighter text-[#121212] opacity-50">{`${date_two_weeks_ago} ~ ${today} `}</span>
        </div>

        <div className="flex flex-row w-full mb-5">
          <RadioButton
            className={"flex flex-row justify-center rounded-sm"}
            tabClassName={"bg-[#F1F1F1] py-2 border-0"}
            selectedClassName={"bg-[#000000] py-2 text-white border-0"}
            bordered
            options={orders}
            selected={selectedOrder}
            selectedTextColor={"WHITE"}
            onSelect={(option) => {
              setSelectedOrder(option)
            }}
          />
        </div>

        <div className="flex flex-row w-full rounded-full bg-[#121212] justify-center items-center text-center py-2 px-3">
          <img className="mr-2" src={ICON_ONEULOOK} alt="logo" />
          <span className="text-sm tracking-tighter text-[#F2F2F2] whitespace-pre">{languageTexts.index_text_14}</span>
        </div>

        <div>{renderProductItems()}</div>

        <div className={`${products && products.length === 10 ? "hidden" : ""}`}>
          <Button
            buttonColor={"BLACK"}
            textColor={"WHITE"}
            text={languageTexts.index_text_15}
            onClick={() => {
              fetchProducts()
            }}
          />
        </div>
      </div>
    )
  }, [selectedOrder, products])

  const Product = (props: any) => {
    return (
      <div className="flex flex-row items-center gap-4 items-center">
        <div className="min-w-[32px]">
          <span className="font-bold font-md tracking-tighter">{props.index}</span>
        </div>
        <div className="w-[80px] h-[80px] rounded-sm overflow-hidden">
          <img className="w-full h-full bg-cover" src={props.product.thumbnailSmUrl} alt={languageTexts.index_text_16} />
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-row">
            <span className="text-sm tracking-tighter truncate max-w-[300px]">{props.product.name}</span>
          </div>
          {/* <div className="flex flex-row gap-3">
            <div className="flex flex-row gap-1 items-center">
              <span className="text-sm tracking-tighter text-[#999999]">
                <b>옷장에 담긴 수</b>
                {` ${props.product.cartCntInTwoWeeks.toLocaleString()}`}
              </span>
            </div>
            <div className="flex flex-row gap-1 items-center">
              <span className="text-sm tracking-tighter text-[#999999]">
                <b>{languageTexts.index_text_17}</b>
                {` ${props.product.views.toLocaleString()}`}
              </span>
            </div>
          </div> */}
          <div className="flex flex-row">
            <span className="text-[#000000] text-sm tracking-tighter">{languageTexts._clothes(props.product.qty)}</span>
            {/* <span className="text-[#999999] text-sm tracking-tighter">
              {languageTexts.index_text_18}
            </span> */}
          </div>
        </div>
      </div>
    )
  }

  const renderProductItems = useCallback(() => {
    return (
      <div className="flex flex-col gap-5 my-5">
        {!products || products.length == 0
          ? null
          : products.map((product: any, index: number) => {
              return <Product key={`product-${uniqueId()}`} index={index + 1} product={product} />
            })}
      </div>
    )
  }, [selectedOrder, products])

  const renderChart = useCallback(() => {
    const fetchChartData = () => {
      API.Chart.index({
        chart: "POSTINGS",
        type: selectedChartDuration.value,
        brandToken: props.auth.token
      })
        .then((response) => {
          const values = response.data.chart.postings

          let chart = {
            data: values,
            borderColor: "BLACK",
            borderWidth: 4,
            backgroundColor: "WHITE",
            pointStyle: "circle",
            pointRadius: 4,
            pointWidth: 8,
            pointBorderColor: "rgb(0, 0, 0)"
          }

          labels.current = response.data.labels
          counts.current = response.data.count

          setSelectedDate({
            date: response.data.labels[response.data.labels.length - 1],
            value: response.data.chart.postings[response.data.chart.postings.length - 1]
          })

          setTimeout(() => {
            setChartData({
              labels: response.data.labels,
              tension: 0.5,
              datasets: [chart]
            })
          }, 400)
        })
        .catch((error) => {
          props.showModal({
            text: languageTexts.index_text_19
          })
        })
    }

    useEffect(() => {
      fetchChartData()
    }, [selectedChartDuration])

    const options = {
      responsive: true,
      maintainAspectRatio: false,

      legend: {
        display: true
      },

      scales: {
        x: {
          ticks: {
            display: false
          },

          grid: {
            lineWidth: 4,
            color: function (context) {
              if (context.tick.label === selectedDate.date) {
                return "rgba(93, 95, 239, 0.2)"
              }
            }
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            display: false
          }
        }
      },

      plugins: {
        tooltip: {
          callbacks: {
            label: (item) => languageTexts._index_text_20(item.formattedValue)
          }
        },
        legend: {
          display: false,
          labels: {
            usePointStyle: true
          }
        },
        title: {
          display: false,
          text: "Chart.js Line Chart"
        },
        zoom: {
          zoom: {
            wheel: {
              enabled: true
            },
            pinch: {
              enabled: true
            },
            mode: "x" as "x"
          },
          pan: {
            enabled: true,
            mode: "x" as "x"
          }
        }
      },

      onClick: function (evt, element) {
        if (element.length > 0) {
          const index = element[0].index
          const value = element[0].element.$context.raw

          setSelectedDate({
            date: labels.current[index],
            value: value
          })
        }
      }
    }

    return (
      <div className="px-5 md:w-[800px] xl:w-[1024px] mx-auto">
        <div className="flex flex-row px-5">
          <div className="mb-4">
            <span className="text-xl font-bold tracking-tighter">{languageTexts.index_text_21}</span>
          </div>
          <div className="ml-auto">
            <RadioButton
              className={"flex flex-row justify-center rounded-sm gap-2"}
              tabClassName={"bg-[#F1F1F1] py-1 px-2 border-0 rounded-md"}
              selectedClassName={"bg-[#000000] py-1 px-2 text-white border-0 rounded-md"}
              textClassName={"text-sm tracking-tighter text-[#1A1A1A] whitespace-pre"}
              selectedTextClassName={"text-sm font-bold tracking-tighter text-white whitespace-pre"}
              bordered
              options={durations}
              selected={selectedChartDuration}
              selectedTextColor={"WHITE"}
              onSelect={(option) => {
                setSelectedChartDuration(option)
              }}
            />
          </div>
        </div>

        <div className="flex flex-row px-5 min-h-[36px]">
          <div className="flex flex-col">
            <span className="text-sm tracking-tighter text-gray-400">{languageTexts._index_text_22(counts.current)}</span>
          </div>
          <div className="flex flex-col ml-auto items-end">
            <span className="text-sm tracking-tighter">{selectedDate ? languageTexts._index_text_23(selectedDate.date.split("-")[0], selectedDate.date.split("-")[1]) : ""}</span>
            <span className="font-bold text-base tracking-tighter text-[#000000]">{selectedDate ? languageTexts._amount(selectedDate.value) : ""}</span>
          </div>
        </div>

        <div className="flex flex-row">{chartData ? <Line options={options} data={chartData} /> : null}</div>
      </div>
    )
  }, [selectedChartDuration, selectedDate, chartData])

  const [postings, setPostings] = useState<any>()
  const searchParams = useRef<any>()
  const postingPage = useRef(1)
  const postingsCount = useRef(0)
  const [isContentEnded, setIsContentEnded] = useState(false)

  const fetchPostings = (refresh?) => {
    if (refresh) {
      postingPage.current = 1
      setPostings(undefined)
    }

    API.Post.index({
      brandToken: props.auth.token,
      brandId: props.brand.id,
      startDt: `${dayjs().subtract(2, "week").format("YYYY-MM-DD")}`,
      endDt: `${dayjs().format("YYYY-MM-DD")}`,
      page: postingPage.current,
      ...searchParams.current
    })
      .then((response) => {
        postingsCount.current = response.data.count

        setPostings(postingPage.current === 1 ? response.data.postings : postings.concat(response.data.postings))

        setIsContentEnded(response.data.paginator.currentPage >= response.data.paginator.lastPage)

        setIsFetching(false)

        postingPage.current = postingPage.current + 1
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  useEffect(() => {
    if (chartData) fetchPostings()
  }, [chartData])

  const [isFetching, setIsFetching] = useInfiniteScroll(() => {
    if (postings && postings.length) {
      fetchPostings()
    }
  })

  const renderLoadingIndicator = () => {
    return isFetching && !isContentEnded ? (
      <div className="flex flex-row mx-10 my-10 justify-center items-center">
        <div className="flex flex-row justify-center text-center my-5">
          <span className="prose prose-xl text-slate-400">{languageTexts.loading_1}</span>
        </div>
      </div>
    ) : null
  }

  const renderPostings = useCallback(() => {
    return postings && postings.length ? (
      <div className="flex flex-col px-8 xl:px-0 mx-auto md:w-[800px] xl:w-[1024px] mt-[64px]">
        <div className="flex flex-row mb-6">
          <div className="flex flex-row gap-1">
            <span className="font-bold tracking-tighter text-xl">{languageTexts.index_text_24}</span>
            <span className="font-bold tracking-tighter text-xl text-[#000000]">{languageTexts._product_qty(postingsCount.current)}</span>
          </div>
          <div
            className="flex flex-row ml-auto items-center cursor-pointer text-gray-400 gap-1"
            onClick={() => {
              navigate(ROUTES.POSTING_INDEX.PATH)
            }}
          >
            <span className="text-sm tracking-tighter text-sm">{languageTexts.index_text_25}</span>
            <ChevronRight size={20} />
          </div>
        </div>

        <div className="flex flex-col gap-[64px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-y-[64px] gap-x-[32px] xl:gap-y-10">
            {postings.map((posting: any) => {
              return (
                <PostingCard
                  posting={posting}
                  key={`posting-${uniqueId()}`}
                  showFeedbacks={false}
                  onUpdate={(posting?: any) => {
                    const postingsCopy = [...postings].map((postingOriginal) => (postingOriginal.id === posting.id ? posting : postingOriginal))

                    setPostings(postingsCopy)
                  }}
                  onLike={(userId: number, result: any) => {
                    const postingsCopy = [...postings].map((postingOriginal) =>
                      postingOriginal.userId === userId
                        ? {
                            ...postingOriginal,
                            ...{
                              likes: result ? [true] : []
                            }
                          }
                        : postingOriginal
                    )

                    setPostings(postingsCopy)
                  }}
                  onSearch={(params: any) => {
                    navigate(ROUTES.POSTING_INDEX.PATH, {
                      state: {
                        ...params
                      }
                    })
                  }}
                />
              )
            })}
          </div>
        </div>
      </div>
    ) : (
      <></>
    )
  }, [postings])

  // useEffect(() => {
  //   return () => {
  //     props.setNotification({ isVisible: false })
  //   }
  // }, [location, props.preferences.isMobile])

  return (
    <>
      {renderBanner()}
      {renderProducts()}
      {renderChart()}
      {renderPostings()}
      {renderLoadingIndicator()}
      <NotificationContainer />
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(ReportIndex)
